import { Outlet } from 'react-router';

import { AdminLayout } from '../../app-layout/admin-layout';

export const AdminLayoutRoute = () => {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
};
